import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs: {
  q: string;
  a: string;
}[] = [{
  q: 'Can’t I find all of this free on YouTube and Pinterest?',
  a: 'You can find poses. You can’t find the words to get them in 40 seconds with 30 people watching, and you can’t find them sequenced to the day with the minutes attached. Inspiration and direction are different things. You’re not paying for information — you’re paying for the script.'
}, {
  q: '300 pages? I have a wedding on Saturday.',
  a: 'You don’t read it. You run it. Print the one-page Printable for each part of the day tonight — that’s six pages — and read only the volume of the part that scares you. If formals are your fear, start with Volume 4.'
}, {
  q: 'Won’t scripts make my photos look stiff? I want candid.',
  a: 'Candid is a result, not a method. “Just act natural” produces the mugshot. Direction produces movement, and movement produces the moment. The progressions are built for exactly that: standing → movement → intimate. The couple never sees a script — they see someone who knows what’s next.'
}, {
  q: 'Every couple is different. No system survives a real wedding.',
  a: 'Right — which is why the system directs situations, not personalities: the light in the room, the size of the group, the minutes you have left, the part of the day. Those repeat at every wedding. The variants — no first look, a church with restrictions, rain, an 8-minute portrait window — are already written.'
}, {
  q: 'Will I sound like I’m reading a script?',
  a: 'Say the lines as written your first Saturday. By your third they’re yours — the Phrase Book even has an exercise for picking the five that sound most like you. What the couple hears isn’t a script. It’s a photographer who never runs out of things to say.'
}, {
  q: 'Is this for beginners or experienced photographers?',
  a: 'Both. If you’re leading your first weddings, it’s the direction nobody teaches you. If you’ve shot forty and still dread formals and timeline chaos, it’s the system that turns those two hours from survival into routine.'
}, {
  q: 'Does it work in my country — and for church, civil, outdoor or elopement weddings?',
  a: 'The structure of the day is the same everywhere: someone gets ready, there’s a ceremony, families want photos, the light leaves, people dance. Venue types, restrictions and variants are covered. You supply the accent.'
}, {
  q: 'How do I get it — and can I actually use it mid-shoot?',
  a: 'Instant PDF download after checkout, on any device. On the day, you don’t scroll it: you print the one-page Printables and clip them to your bag. The formals calling order is built to be memorized.'
}, {
  q: 'I’ve bought posing guides before. They’re in a drawer.',
  a: 'This isn’t 200 Pinterest screenshots. Every pose has the words to get it, the minutes it takes and where it sits in the day — and every volume ends in a printable you actually use on Saturday. And if it ends up in a drawer anyway: 30 days, full refund.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-132" data-mp="38mzd3pr0dv2r">
      <div className="mx-auto max-w-3xl px-5" data-id="element-133" data-mp="3dgaps7ii562l">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-134" data-mp="3ielz8h4vxeka">
          Questions, answered
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-135" data-mp="3nd6yad8ehs75" />

        <ul className="mt-12 divide-y divide-gold-soft/70 border-y border-gold-soft/70" data-id="element-136" data-mp="3rfad9bua3ex6">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} data-id="element-137" data-mp="1x1ahdttxsddv" data-mpi={index}>
                <h3 data-id="element-138" data-mp="1x22fbbb0an7b">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-139" data-mp="1x2kg8l8m5plk">
                    <span className="font-serif text-lg sm:text-xl text-ink" data-id="element-140" data-mp="1go3arnq6wub7">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-141" data-mp="1bpa7eo4major" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-142" data-mp="xpr01xjmrcdi">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.4, 0, 0.2, 1]
              }} className="overflow-hidden" data-id="element-143" data-mp="sz27eew7s9cs">
                      <p className="pb-7 pr-10 text-[15px] leading-relaxed text-ink-soft" data-id="element-144" data-mp="2bw5i1iyvpaxi">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}